'use strict';

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeZoneFile = makeZoneFile;

var _zoneFileTemplate = require("./zoneFileTemplate");

function makeZoneFile(jsonZoneFile) {
  var template = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _zoneFileTemplate.getZoneFileTemplate)();
  template = processOrigin(jsonZoneFile['$origin'], template);
  template = processTTL(jsonZoneFile['$ttl'], template);
  template = processSOA(jsonZoneFile['soa'], template);
  template = processNS(jsonZoneFile['ns'], template);
  template = processA(jsonZoneFile['a'], template);
  template = processAAAA(jsonZoneFile['aaaa'], template);
  template = processCNAME(jsonZoneFile['cname'], template);
  template = processMX(jsonZoneFile['mx'], template);
  template = processPTR(jsonZoneFile['ptr'], template);
  template = processTXT(jsonZoneFile['txt'], template);
  template = processSRV(jsonZoneFile['srv'], template);
  template = processSPF(jsonZoneFile['spf'], template);
  template = processURI(jsonZoneFile['uri'], template);
  template = processValues(jsonZoneFile, template);
  return template.replace(/\n{2,}/gim, '\n\n');
}

;

function processOrigin(data, template) {
  var ret = '';

  if (typeof data !== 'undefined') {
    ret += '$ORIGIN ' + data;
  }

  return template.replace('{$origin}', ret);
}

;

function processTTL(data, template) {
  var ret = '';

  if (typeof data !== 'undefined') {
    ret += '$TTL ' + data;
  }

  return template.replace('{$ttl}', ret);
}

;

function processSOA(data, template) {
  var ret = template;

  if (typeof data !== 'undefined') {
    data.name = data.name || '@';
    data.ttl = data.ttl || '';

    for (var key in data) {
      var value = data[key];
      ret = ret.replace('{' + key + '}', value + '\t');
    }
  }

  return ret;
}

;

function processNS(data, template) {
  var ret = '';

  if (data) {
    var _iterator = _createForOfIteratorHelper(data),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var record = _step.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tNS\t' + record.host + '\n';
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return template.replace('{ns}', ret);
}

;

function processA(data, template) {
  var ret = '';

  if (data) {
    var _iterator2 = _createForOfIteratorHelper(data),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var record = _step2.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tA\t' + record.ip + '\n';
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return template.replace('{a}', ret);
}

;

function processAAAA(data, template) {
  var ret = '';

  if (data) {
    var _iterator3 = _createForOfIteratorHelper(data),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var record = _step3.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tAAAA\t' + record.ip + '\n';
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return template.replace('{aaaa}', ret);
}

;

function processCNAME(data, template) {
  var ret = '';

  if (data) {
    var _iterator4 = _createForOfIteratorHelper(data),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var record = _step4.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tCNAME\t' + record.alias + '\n';
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return template.replace('{cname}', ret);
}

;

function processMX(data, template) {
  var ret = '';

  if (data) {
    var _iterator5 = _createForOfIteratorHelper(data),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var record = _step5.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tMX\t' + record.preference + '\t' + record.host + '\n';
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return template.replace('{mx}', ret);
}

;

function processPTR(data, template) {
  var ret = '';

  if (data) {
    var _iterator6 = _createForOfIteratorHelper(data),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var record = _step6.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tPTR\t' + record.host + '\n';
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }

  return template.replace('{ptr}', ret);
}

;

function processTXT(data, template) {
  var ret = '';

  if (data) {
    var _iterator7 = _createForOfIteratorHelper(data),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var record = _step7.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tTXT\t';
        var txtData = record.txt;

        if (typeof txtData === 'string') {
          ret += '"' + txtData + '"';
        } else if (txtData instanceof Array) {
          ret += txtData.map(function (datum) {
            return '"' + datum + '"';
          }).join(' ');
        }

        ret += '\n';
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }

  return template.replace('{txt}', ret);
}

;

function processSRV(data, template) {
  var ret = '';

  if (data) {
    var _iterator8 = _createForOfIteratorHelper(data),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var record = _step8.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tSRV\t' + record.priority + '\t';
        ret += record.weight + '\t';
        ret += record.port + '\t';
        ret += record.target + '\n';
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  return template.replace('{srv}', ret);
}

;

function processSPF(data, template) {
  var ret = '';

  if (data) {
    var _iterator9 = _createForOfIteratorHelper(data),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var record = _step9.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tSPF\t' + record.data + '\n';
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }

  return template.replace('{spf}', ret);
}

;

function processURI(data, template) {
  var ret = '';

  if (data) {
    var _iterator10 = _createForOfIteratorHelper(data),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var record = _step10.value;
        ret += (record.name || '@') + '\t';
        if (record.ttl) ret += record.ttl + '\t';
        ret += 'IN\tURI\t' + record.priority + '\t';
        ret += record.weight + '\t';
        ret += '"' + record.target + '"\n';
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }

  return template.replace('{uri}', ret);
}

;

function processValues(jsonZoneFile, template) {
  template = template.replace('{zone}', jsonZoneFile['$origin'] || (jsonZoneFile['soa'] ? jsonZoneFile['soa']['name'] : false) || '');
  template = template.replace('{datetime}', new Date().toISOString());
  var time = Math.round(Date.now() / 1000);
  return template.replace('{time}', "".concat(time));
}

;